import api from "../../../api/api";
import { PaymentTerm } from "../types";

const BASE_URL = "/crm/v1/payment-terms/";

export const getPaymentTermsList = (
  page: number,
  filters: any
) => {
  return api.get(BASE_URL, {
    params: {
      page,
      name__icontains: filters.name,
      description__icontains: filters.description,
      is_active: filters.is_active,
      ordering: filters.ordering,
    },
  });
};

export const createPaymentTerm = (data: any) => {
  return api.post(BASE_URL, data);
};

export const updatePaymentTerm = (id: number, data: any) => {
  return api.put(`${BASE_URL}${id}/`, data);
};

export const getPaymentTermById = (id: number) => {
  return api.get(`${BASE_URL}${id}/`);
};

export const getActivePaymentTerms = () => {
  return api.get(BASE_URL, {
    params: {
      is_active: true,
    },
  });
};